import { render, staticRenderFns } from "./actionColdClient.vue?vue&type=template&id=39f20603&scoped=true&"
import script from "./actionColdClient.vue?vue&type=script&lang=js&"
export * from "./actionColdClient.vue?vue&type=script&lang=js&"
import style0 from "./actionColdClient.vue?vue&type=style&index=0&id=39f20603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f20603",
  null
  
)

export default component.exports